import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "footer-contact-links" };
import PButton from 'primevue/button';
import { vDataLink } from '../utils/data-link-directive';
export default /*@__PURE__*/ _defineComponent({
    __name: 'footer-contact-links',
    props: {
        isAuthenticated: { type: Boolean },
        links: { default: () => [{
                    label: 'Contact Curtin Connect',
                    url: 'https://www.curtin.edu.au/students/connect/',
                    authenticatedUrl: 'https://students.connect.curtin.edu.au/app/ask'
                }, {
                    label: 'Visit OASIS help',
                    url: 'https://www.curtin.edu.au/students/essentials/it/guides/oasis/',
                }] }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links, (link) => {
                        return _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                            key: link.url,
                            as: "a",
                            severity: "tertiary",
                            rounded: "",
                            href: __props.isAuthenticated ? link.authenticatedUrl ?? link.url : link.url,
                            title: link.tooltip,
                            rel: "noopener",
                            class: "footer-contact-link"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(link.label), 1)
                            ]),
                            _: 2
                        }, 1032, ["href", "title"])), [
                            [_unref(vDataLink), { area: 'oasis-footer', category: 'contact-link', link }]
                        ]);
                    }), 128))
                ])
            ]));
        };
    }
});
